<template>
    <div>
        <br aria-hidden="true"/>
        <br aria-hidden="true"/>
        <div class="row">
            <div class="col-sm-2"></div>
            <div class="bg-register col-sm-8">
                <h1 v-if="!resetComplete">{{ LG('RP_changePassword')}}</h1>
                <h1 v-if="resetComplete">{{showSuccessOrFailMessage()}}</h1>
                <br aria-hidden="true"/>
                <p v-show="errors.length" ref="errors">
                    <b>{{LG('RP_errorMessage')}}</b>
                    <ul>
                        <li v-for="error in errors" v-bind:key="error">{{error}}</li>
                    </ul>
                </p>
                <p v-show="resetComplete">
                    <br aria-hidden="true"/>
                    <b-button v-on:click="onContinueButtonClicked()" class="btn btn-primary">{{LG('RP_continueLabel')}}</b-button>
                </p>

                <div class="form-container">
                    <!--Note: if you add required to each of the input fields (or type="email"),
        it does a nice built-in tooltip, but problem is it's only in English, so we'll make our own checks for now-->
                    <b-form @submit.prevent="handleSubmit" v-show="!resetComplete">
                        <b-form-group :label="LG('RP_emailLabel')" label-for="email">
                            <b-form-input disabled id="email" v-model="user.email" :placeholder="LG('RP_emailPlaceholder')"></b-form-input>
                        </b-form-group>
                        <b-form-group :label="LG('RP_newPasswordLabel')" label-for="password">
                            <b-form-input id="password" type="password" v-model="user.password" :placeholder="LG('RP_passwordPlaceholder')"></b-form-input>
                        </b-form-group>
                        <b-form-group :label="LG('RP_confirmPasswordLabel')" label-for="passwordConfirmId">
                            <b-form-input id="passwordConfirmId" type="password" v-model="passwordConfirm" :placeholder="LG('RP_confirmPasswordLabel')"></b-form-input>
                        </b-form-group>
                        <div>
                            <!--Show reset button, or when resetting show spinner and disable button-->
                            <button v-show="!resetting" class="btn btn-secondary funky-shape">{{LG('RP_resetLabel')}}</button>
                            <button v-show="resetting" class="btn btn-secondary funky-shape" disabled>{{LG('RP_resetLabel')}}</button>
                            <img v-show="resetting" :src="spinnerUrl" alt=""/>
                            <b-link to="/" class="btn btn-link">{{LG('RP_cancelLabel')}}</b-link>
                        </div>
                    </b-form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {

                // Images
                spinnerUrl: "data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==",

                // Variables
                user: {
                    email: "",
                    password: "",
                    passwordhash: "",
                },
                passwordConfirm: "",
                errors: [],
                resetting: false,
                resetComplete: false,
                maxPasswordLength: 30,

            }
        },
        computed: {

        },
        methods: {

            showSuccessOrFailMessage() {
                if (this.errors.length == 0) {
                    return this.LG("RP_changePasswordSuccess");
                } else {
                    return this.LG("RP_changePasswordFail");
                }
            },
            isResettingString() {
                if (this.resetting) {
                    return "true";
                } else {
                    return "false";
                }
            },
            handleSubmit() {

                this.loadUserFromParams();

                this.errors = [];

                if (!this.user.password) {
                    this.setError(this.LG("RP_passwordRequired"));
                } else if (this.user.password.length > this.maxPasswordLength) {
                    this.setError(this.LG("RP_passwordMaxLength") + this.maxPasswordLength);
                } else if (this.user.password != this.passwordConfirm) {
                    this.setError(this.LG("RP_passwordsDontMatch"));
                }

                // No errors, so submit!
                if (!this.errors.length) {

                    this.resetPassword(this.user);
                }else{
                    const errorDiv = this.$refs.errors;
                    errorDiv.tabIndex = "-1"
                    this.$nextTick(() => {
                         errorDiv.focus();
                    })
                }
            },
            resetPassword(user) {

                // TBD - might be nice to do auto login but all that code is in login module, needs re-work, so for now don't
                //this.$store.commit('startLogin');

                this.resetting = true;
                this.resetComplete = false;

                const requestOptions = {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(user)
                };

                // This posts the user structure to the register function of the UsersController
                return fetch(`/users/reset`, requestOptions).then(this.handleResponse)
                    .then(user => {
                        // login successful if there's a jwt token in the response
                        if (user != null && user.token != null) {
                            //// store user details and jwt token in local storage to keep user logged in between page refreshes
                            //var userStringText = JSON.stringify(user);
                            //console.log("***** STORING User = " + userStringText);
                            //localStorage.setItem('user', userStringText);
                            //this.$store.commit('completeLogin', user);

                            //// Load in our game state - if this table doesn't exist yet, this will create one in DB as well
                            //this.loadGameState();

                            console.log(" RESET COMPLETE! ");

                        } else {
                            console.log("NO User token found!");
                        }

                        this.resetting = false;
                        this.resetComplete = true;

                        return user;
                    });

            },
            handleResponse(response) {
                console.log("Received response: " + response);

                if (response == null) {
                    console.log("response is null");
                    return;
                }
                return response.text().then(text => {
                    const data = text && JSON.parse(text);
                    if (!response.ok) {

                        console.log("response is not OK, logging out.");
                        this.$store.dispatch('logout');

                        const error = (data && data.message) || response.statusText;
                        this.setError(error);

                        return Promise.reject(error);
                    }
                    return data;
                }).catch((err) => {
                    if (this.errors.length == 0) {
                        this.setError("Échec de connexion");
                    }
                    console.log("Error was caught: " + err);
                });
            },
            setError(text) {
                this.errors.push(text);
            },
            onContinueButtonClicked() {
                this.$router.push("/");
            },
            onCancelButtonClicked() {
                this.$router.push("/");
            },
            loadUserFromParams() {
                this.user.passwordHash = this.$route.query.url;
                this.user.email = this.$route.query.email;
                console.log("passHash: " + this.user.passwordHash + " Email: " + this.user.email);
            },
        },
        mounted() {

            // TBD how do we make bootstrap-vue validation messages come out in French, if not do-able we'll fallback to manual system above
            // this.$i18n.locale = 'fr';  // This doesn't quite work, but is on the right track...

            this.loadUserFromParams();

        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    .form-container {
        padding: 10px;
    }
    .bg-register {
        background-color: #CDEAE9;
        padding: 30px;
        border: 2px solid white;
        border-radius: 25px;
    }
</style>